module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\nuniform sampler2D tInput;\nuniform sampler2D tInput2;\nuniform vec2 resolution;\nuniform float opacity;\n\nvoid main() {\n\n  \n  vec4 base = texture2D( tInput, vUv );\n  vec4 blend = texture2D( tInput2, vUv );\n\n  gl_FragColor = (1.0 - ((1.0 - base) * (1.0 - blend)));\n}"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/Trail/modules/postprocessing/quad/blend/main.frag
// module id = i/8f
// module chunks = 1